(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-nps-open-search]').forEach((link) => {
      if (link.dataset.npsInitialized) return;
      const dialog = document.getElementById(link.dataset.npsOpenSearch);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      link.dataset.npsInitialized = 'true';
      link.addEventListener('click', (event) => {
        event.preventDefault();
        document.querySelectorAll('[data-nps-menu][open]').forEach((menu) => { menu.open = false; });
        dialog.showModal();
        dialog.querySelector('input[type="search"]')?.focus();
      });
      dialog.querySelector('[data-nps-close-search]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => link.focus());
    });
    scope.querySelectorAll('[data-nps-menu]').forEach((menu) => {
      if (menu.dataset.npsInitialized) return;
      menu.dataset.npsInitialized = 'true';
      menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => { menu.open = false; }));
      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        menu.open = false;
        menu.querySelector('summary')?.focus();
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-nps-menu][open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  window.matchMedia('(min-width:1051px)').addEventListener('change', (event) => {
    if (event.matches) document.querySelectorAll('[data-nps-menu][open]').forEach((menu) => { menu.open = false; });
  });
})();
